import { render, staticRenderFns } from "./SideModalSetting.vue?vue&type=template&id=53404caa"
import script from "./SideModalSetting.vue?vue&type=script&lang=js"
export * from "./SideModalSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports